const URL_PARAM_PATTERN = /\/(\d+)/g

export function getStandardizedPathname(pathname: string): string {
  return URL_PARAM_PATTERN.test(pathname) ? pathname.replace(URL_PARAM_PATTERN, '/ID') : pathname
}
